import { CALYPSO, OZ, LORAX, SORBET, THUNDERDOME, MARIGOLD, NORMAN, CANDY_APPLE } from 'HubStyleTokens/colors';
/**
 * @deprecated use marketplace-ui-common
 */

export let FEATURED_CALLOUT_COLOR_TYPES;
/**
 * @deprecated use marketplace-ui-common
 */

(function (FEATURED_CALLOUT_COLOR_TYPES) {
  FEATURED_CALLOUT_COLOR_TYPES["THUNDERDOME_TO_CALYPSO"] = "THUNDERDOME_TO_CALYPSO";
  FEATURED_CALLOUT_COLOR_TYPES["CALYPSO_TO_OZ"] = "CALYPSO_TO_OZ";
  FEATURED_CALLOUT_COLOR_TYPES["SORBET_TO_MARIGOLD"] = "SORBET_TO_MARIGOLD";
  FEATURED_CALLOUT_COLOR_TYPES["NORMAN_TO_CANDY_APPLE"] = "NORMAN_TO_CANDY_APPLE";
  FEATURED_CALLOUT_COLOR_TYPES["CANDY_APPLE_TO_LORAX"] = "CANDY_APPLE_TO_LORAX";
  FEATURED_CALLOUT_COLOR_TYPES["LORAX_TO_SORBET"] = "LORAX_TO_SORBET";
})(FEATURED_CALLOUT_COLOR_TYPES || (FEATURED_CALLOUT_COLOR_TYPES = {}));

export const FEATURED_CALLOUT_COLORS = {
  [FEATURED_CALLOUT_COLOR_TYPES.THUNDERDOME_TO_CALYPSO]: [THUNDERDOME, CALYPSO],
  [FEATURED_CALLOUT_COLOR_TYPES.CALYPSO_TO_OZ]: [CALYPSO, OZ],
  [FEATURED_CALLOUT_COLOR_TYPES.SORBET_TO_MARIGOLD]: [SORBET, MARIGOLD],
  [FEATURED_CALLOUT_COLOR_TYPES.NORMAN_TO_CANDY_APPLE]: [NORMAN, CANDY_APPLE],
  [FEATURED_CALLOUT_COLOR_TYPES.CANDY_APPLE_TO_LORAX]: [CANDY_APPLE, LORAX],
  [FEATURED_CALLOUT_COLOR_TYPES.LORAX_TO_SORBET]: [LORAX, SORBET]
};
/**
 * @deprecated use marketplace-ui-common
 */

export let FEATURED_CALLOUT_LAYOUT_TYPES;

(function (FEATURED_CALLOUT_LAYOUT_TYPES) {
  FEATURED_CALLOUT_LAYOUT_TYPES["FULL_WIDTH"] = "FULL_WIDTH";
  FEATURED_CALLOUT_LAYOUT_TYPES["MULTI"] = "MULTI";
})(FEATURED_CALLOUT_LAYOUT_TYPES || (FEATURED_CALLOUT_LAYOUT_TYPES = {}));